import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useApiClient } from "../../../api";
import { enqueueSnackbar } from "notistack";

export const SyncSchoolDialog = ({ open, setOpen, school, onSyncStart }) => {
  const ApiClient = useApiClient();

  const handleStartSyncClicked = async () => {
    try {
      const response = await ApiClient.wonde.startSchoolSync({
        school: school.id,
      });
      if (response.success) {
        enqueueSnackbar("Successfully started sync", {
          variant: "success",
          autoHideDuration: 3000,
        });
        setOpen(false);
        onSyncStart();
      } else {
        enqueueSnackbar(`${response.message}`, {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      console.error("Failed to start sync", error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth={"md"}
    >
      <DialogTitle>Re-sync school</DialogTitle>
      <DialogContent>
        Are you sure you want to do this? It will start a new sync of the school
        data.
      </DialogContent>
      <DialogActions>
        <Button variant={"outlined"} onClick={handleStartSyncClicked}>
          Confirm
        </Button>
        <Button onClick={() => setOpen(false)} variant={"contained"}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
